import React, { useEffect, useMemo, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import "./HarrisChainOfThought.scss";

const HarrisChainOfThought = ({ steps = [] }) => {
    const normalizedSteps = useMemo(
        () =>
            steps.map((step) =>
                typeof step === "string"
                    ? { title: step, items: [] }
                    : { title: step?.title ?? "", items: step?.items ?? [] }
            ),
        [steps]
    );

    const [open, setOpen] = useState(
        normalizedSteps.map((_, idx) => idx === normalizedSteps.length - 1)
    );

    useEffect(() => {
        setOpen(normalizedSteps.map((_, idx) => idx === normalizedSteps.length - 1));
    }, [normalizedSteps]);

    if (!normalizedSteps.length) return null;

    const toggle = (idx) => {
        setOpen((prev) => prev.map((isOpen, i) => (i === idx ? !isOpen : isOpen)));
    };

    const activeIndex = normalizedSteps.length - 1;

    return (
        <div className="harris-cot">
            {normalizedSteps.map((step, index) => {
                const hasItems = step.items && step.items.length > 0;
                const isOpen = open[index];
                const isActiveStep = index === activeIndex;
                return (
                    <div className="cot-step" key={index}>
                        <div className="cot-left">
                            <span className={`cot-node ${isActiveStep ? "is-active" : ""}`} />
                            {index < normalizedSteps.length - 1 && <span className="cot-connector" />}
                        </div>
                        <div className={`cot-body ${isActiveStep ? "is-active" : ""}`}>
                            <button
                                type="button"
                                className="cot-trigger is-toggle"
                                onClick={() => toggle(index)}
                                aria-expanded={isOpen}
                                aria-label="Toggle step"
                            >
                                <span>{step.title}</span>
                                {isOpen ? (
                                    <FiChevronUp className="cot-chevron" />
                                ) : (
                                    <FiChevronDown className="cot-chevron" />
                                )}
                            </button>
                            {hasItems && isOpen && (
                                <div className="cot-content">
                                    {step.items.map((item, itemIdx) => (
                                        <div
                                            className={`cot-item ${isActiveStep ? "is-animating" : ""}`}
                                            key={itemIdx}
                                        >
                                            {item}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default HarrisChainOfThought;
